import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface CheckupUrlConfig {
  checkupUrl: string;
}

export const checkupUrlConfig: CheckupUrlConfig = {
  checkupUrl: environment.checkupUrl,
};

export const CHECKUP_URL_CONFIG = new InjectionToken<CheckupUrlConfig>('checkupUrlConfig');
